import { render, staticRenderFns } from "./the-notification-permission-bar.vue?vue&type=template&id=4add9182"
import script from "./the-notification-permission-bar.vue?vue&type=script&lang=js"
export * from "./the-notification-permission-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports